export default {

    all: {

        paypal: 'paypal',
        visa: 'visa',
        mastercard: 'mastercard-1',
        amex: 'american-express',
        discover: 'discover'

    },
    Paypal: {

        main: 'paypal',
        support: {

            visa: 'visa',
            mastercard: 'mastercard-1',
            amex: 'american-express',
            discover: 'discover'

        }

    }

};
